<div class="border-solid rounded-lg shadow-md" (click)="postClick($event)">
  <div class="p-4">
    <div class="mb-4">
      <span
        *ngIf="post.isFlagged"
        class="border-solid border border-red-600 rounded p-1 text-sm text-red-600"
        >Flagged Post</span
      >
    </div>
    <div class="flex justify-between">
      <div class="flex items-center">
        <div class="mr-2" (click)="imageClick($event)">
          <img
            class="inline-block h-10 w-10 rounded-full"
            [src]="post.creatorNft"
            alt=""
          />
        </div>
        <div class="flex flex-col">
          <span>{{ post.creator }}</span>
          <span class="text-gray-500 text-xs">{{
            post.createdDateTime | timeAgo
          }}</span>
        </div>
      </div>

      <div class="flex items-center">
        <div class="flex items-center">
          <ark-icon icon="display"></ark-icon>
          <span class="text-gray-500 text-sm">{{ post.creditsPerClick }}</span>
        </div>
      </div>
    </div>
    <div class="mt-5 flex flex-col">
      <span class="mb-2 font-bold">{{ post.title }}</span>

      <div class="mt-2" *ngIf="post.images.length">
        <ark-ui-blur [blured]="blured">
          <img
            class="w-full h-full object-cover"
            [src]="post.images[0].thumb"
            alt=""
          />
        </ark-ui-blur>
      </div>

      <div class="flex flex-col mt-2">
        <span class="text-gray-500" [class.line-clamp-2]="twoLines">{{
          post.description | limitcharacter : limitCharacters
        }}</span>
      </div>
    </div>
    <div class="mt-3 flex justify-between items-center">
      <ark-ui-post-wisee [post]="post"></ark-ui-post-wisee>
    </div>
  </div>

  <div>
    <ark-ui-og [post]="post"></ark-ui-og>
  </div>
</div>
